import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ValidateRequest, ValidateResponse, ApiError } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/showcase/validate
 * p95 target < 150ms.
 * Note: 422 SHOWCASE-422-001 is an INTENDED demo result — treated as a
 * successful demo response, not a UI error. The ApiError is surfaced as
 * `demoError` in the result card.
 */
export function useValidateDemo() {
  return useMutation<ValidateResponse, ApiError, ValidateRequest>({
    mutationFn: (req) => showcaseApi.validate(req),
    mutationKey: ['common-showcase', 'validate'],
  });
}
